import React from 'react';
import {useSelector} from 'react-redux';
import {MenuItem, InputLabel} from '@material-ui/core';
import {TextEnum} from 'ContentItem/Search/SearchTypes';
import {SelectType} from './types';
import {selectEnumType} from './Redux/selectors';
import {EnumTypes} from './EnumTypes';
import {head} from '../utils';

const createOption = ([key, value]: [string, string]) => (
    <MenuItem key={key} value={key}>
        {value}
    </MenuItem>
);

export const getInputLabel = (variant: string, placeholder = '') => {
    if (variant === 'outlined') return null;

    return <InputLabel id="artwork-type-label">{placeholder}</InputLabel>;
};

export default function EnumTypesContainer(props: SelectType) {
    const {
        onChange,
        enumType,
        value = '',
        placeholder = '',
        variant = 'standard',
        sortOrder = [],
        disabled,
    } = props;

    const types = useSelector(selectEnumType(enumType)) || {};

    const optsSorted = Object.entries(types as TextEnum).sort(
        (a, b) => sortOrder.indexOf(head(a)) - sortOrder.indexOf(head(b))
    );

    const opts = optsSorted.map(createOption);

    const inputLabel = getInputLabel(variant, placeholder);

    const formStyle = {
        minWidth: 200,
    };

    return (
        <EnumTypes
            formStyle={formStyle}
            inputLabel={inputLabel}
            value={value}
            onChange={onChange}
            variant={variant}
            opts={opts}
            name={enumType}
            disabled={disabled}
        />
    );
}
